<template>
  <div>
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />
    <about-author 
      :profile="profile" 
      @refreshProfile="handleRefreshProfile" 
    />
    
    <div class="pt-30 pb-50">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <el-menu 
              :default-active="activeMenu" 
              mode="vertical"
              background-color="#f5f7fa"
              text-color="#303133"
              active-text-color="#409EFF"
              @select="handleSelect"
            >
              <el-menu-item index="1">基本信息</el-menu-item>
              <el-menu-item index="2" v-if="initPwd === 'false'">
                初始化密码
                <el-badge is-dot class="mt-2"></el-badge>
              </el-menu-item>
              <el-menu-item index="3" v-if="initPwd === 'true'">
                修改密码
              </el-menu-item>
            </el-menu>
          </div>

          <div class="col-lg-9">
            <Form 
              v-if="activeMenu === '1'" 
              :profile="profile" 
              @refreshProfile="handleRefreshProfile" 
              :defaultEmail="emailFromRoute"
            />
            
            <InitPwd 
              v-else-if="activeMenu === '2'" 
              :profile="profile" 
              @refreshProfile="handleRefreshProfile" 
            />

            <ChgPwd 
              v-else-if="activeMenu === '3'" 
              :profile="profile" 
              @refreshProfile="handleRefreshProfile" 
            />

          </div>

          <!--
          <div class="col-lg-4">
            <div class="contact-sidebar">
              <FromCount />
              <signup-style-two />
            </div>
          </div>
          -->
        </div>
      </div>
    </div>
    <footer-one />
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Drawer from "../Mobile/Drawer.vue";
import FooterOne from "../Utility/Footer/FooterOne.vue";
import Header from "../Utility/Header/index";
import AboutAuthor from "./AboutAuthor.vue";
import Form from "./Form.vue";
import InitPwd from "./InitPwd.vue";
import ChgPwd from "./ChgPwd.vue";
// import FromCount from "../Utility/FollowCount/index";
// import SignupStyleTwo from '../Utility/Signup/SignupStyleTwo.vue';
import profileService from '@/utils/profileService'; // 导入共享模块
import { getProfile } from "@/api/user"; // 备用：若缓存不存在则请求

export default {
  components: {
    Header,
    AboutAuthor,
    Form,
    FooterOne,
    Drawer,
    InitPwd,
    ChgPwd,
  },
  data: () => ({
    sidebar: false,
    activeMenu: '1'
  }),
  computed: {
    profile() {
      return profileService.getProfile();
    },
    initPwd() {
      return localStorage.getItem('initpwd');
    },
    emailFromRoute() {
      return this.$route.query.email || '';
    }
  },
  watch: {
    profile(newVal) {
      console.log('profile 数据加载完成:', newVal); 
      if (!this.profile && localStorage.getItem('token')) {
        this.getUserProfile();
      }
      if (!this.profile || !this.profile.id) {
        setTimeout(() => {
          this.$router.push('/');
        }, 1000);
      }
    },
    $route() {
      this.setActiveMenuFromRoute();
    }
  },
  created() {
    this.setActiveMenuFromRoute();  // 初始化时从路由获取状态
    document.addEventListener("scroll", this.topToBottom);
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    handleRefreshProfile() {
      this.getUserProfile();
      console.log('handleRefreshProfile:',this.profile);
    },
    async getUserProfile() {
      try {
        const response = await getProfile();
        profileService.setProfile(response.data); // 确保设置缓存
      } catch (error) {
        console.error('Profile 组件加载 profile 失败:', error);
      }
    },
    // 根据路由参数设置菜单激活状态
    setActiveMenuFromRoute() {
      const tab = this.$route.query.tab;
      this.activeMenu = ['1', '2', '3'].includes(tab) ? tab : '1';
    },
    handleSelect(key) {
      this.activeMenu = key; 
      if (this.$route.query.tab !== key) {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: key } 
        });
      }
    }
  },
};
</script>

<style>
.el-badge__content.is-dot {
  height: 8px!important;
}
</style>
